module.exports = __webpack_public_path__ + "static/media/icon-grundversicherung.aafe670e.svg";